var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseModal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1751_42213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.48837 15.0001C5.39179 15.0001 5.29736 14.9715 5.21705 14.9178C5.13674 14.8642 5.07414 14.7879 5.03717 14.6987C5.00021 14.6094 4.99054 14.5112 5.00939 14.4165C5.02824 14.3218 5.07475 14.2348 5.14306 14.1665L14.1665 5.14303C14.2581 5.05145 14.3823 5 14.5118 5C14.6413 5 14.7656 5.05145 14.8571 5.14303C14.9487 5.23462 15.0002 5.35883 15.0002 5.48835C15.0002 5.61786 14.9487 5.74208 14.8571 5.83366L5.83369 14.8571C5.78838 14.9025 5.73455 14.9385 5.67529 14.963C5.61603 14.9876 5.55251 15.0002 5.48837 15.0001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5118 15.0001C14.4477 15.0002 14.3842 14.9876 14.3249 14.963C14.2657 14.9385 14.2118 14.9025 14.1665 14.8571L5.14309 5.83366C5.05151 5.74208 5.00006 5.61786 5.00006 5.48835C5.00006 5.35883 5.05151 5.23462 5.14309 5.14303C5.23468 5.05145 5.35889 5 5.48841 5C5.61792 5 5.74214 5.05145 5.83372 5.14303L14.8572 14.1665C14.9255 14.2348 14.972 14.3218 14.9908 14.4165C15.0097 14.5112 15 14.6094 14.963 14.6987C14.9261 14.7879 14.8635 14.8642 14.7832 14.9178C14.7029 14.9715 14.6084 15.0001 14.5118 15.0001Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1751_42213"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 10,
    height: 10,
    rx: 5,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseModal);
export default __webpack_public_path__ + "static/media/close-modal.a19d958174518b3b4606b6219f05043e.svg";
export { ForwardRef as ReactComponent };